// extracted by mini-css-extract-plugin
module.exports = {"downloadModal":"styles_downloadModal__3ZEfD"};